export default __webpack_public_path__ + "static/DanzzaBold-d8fe2c3e6e826b9d43f24a799be383e0.eot";